import expandItemPartOnIsReadChanged from './expandItemPartOnIsReadChanged';
import store from 'owa-mail-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
export default action('markItemReadInReadingPane')(select({
    message: function (itemId) { return store.items.get(itemId); },
})(function markItemReadInReadingPaneStore(itemId, isReadValueToSet, state) {
    if (state.message.IsRead && !isReadValueToSet) {
        expandItemPartOnIsReadChanged(state.message.ConversationId.Id, [
            state.message.InternetMessageId,
        ]);
    }
    state.message.IsRead = isReadValueToSet;
}));
//# sourceMappingURL=markItemReadInReadingPaneStore.js.map